import React, {useState} from 'react';
import SalesOneCounterparty from "../components/SalesOneCounterparty";
import axios from "../../../helpers/axios";
import {useNavigate} from "react-router";
import {Link, useLocation} from "react-router-dom";
import {SalesRegisterListRoute} from "../../routesConstants";
import {Helmet} from "react-helmet";
import SaleRegister from "../components/SaleRegister";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";

const CreateSalesRegister = () => {
  const [loading,setLoading] = useState(false)
  const navigate = useNavigate()
  const { search } = useLocation()
  const buyerId = new URLSearchParams(search).get('id')
  const createRegister = (data) =>{
    setLoading(true)
    axios.put("/api/salesRegister/", data)
      .then(()=>{
        if(data.alert) window.alert('Реестр сохранен!')
        navigate(SalesRegisterListRoute)
      })
      .finally(()=>setLoading(false))
  }
  return (
    <div>
      <Helmet>
        <title>Реестр продаж</title>
      </Helmet>
      <Breadcrumbs aria-label="Breadcrumb" style={{paddingBottom: 15}}>
        <Link to={SalesRegisterListRoute}>Список покупателей</Link>
        {buyerId && <Link to={`${SalesRegisterListRoute}/${buyerId}`}>Список реестров</Link>}
        <Typography color="textPrimary">Создание</Typography>
      </Breadcrumbs>
      <SaleRegister cb={createRegister} saving={loading}/>
    </div>
  );
};

export default CreateSalesRegister;
